/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon16Light = forwardRef('ArrowDCornerUpLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.146 1.646a.5.5 0 1 1 .708.708L3.207 6H11.5A2.5 2.5 0 0 1 14 8.5v6a.5.5 0 1 1-1 0v-6A1.5 1.5 0 0 0 11.5 7H3.207l3.647 3.646a.5.5 0 0 1-.708.708L2.495 7.702a1.7 1.7 0 0 1 0-2.404l3.651-3.652Z" })));
});
